import { render } from "./ParentProfile.vue?vue&type=template&id=b3c7c6f8&scoped=true"
import script from "./ParentProfile.vue?vue&type=script&lang=js"
export * from "./ParentProfile.vue?vue&type=script&lang=js"

import "./ParentProfile.vue?vue&type=style&index=0&id=b3c7c6f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c7c6f8"]])

export default __exports__